export default __webpack_public_path__ + "static/media/golingo-town-a.fe81fc36.jpg";